import { NodeFlags } from "../Const";
import { Event } from "../events/Event";
import { EventDispatcher } from "../events/EventDispatcher";
import { Pool } from "../utils/Pool";
import { ILaya } from "../../ILaya";
import { OutOfRangeError } from "../utils/Error";
const ARRAY_EMPTY = [];
const initBits = NodeFlags.ACTIVE;
const reactiveBits = NodeFlags.DISPLAY;
export class Node extends EventDispatcher {
    get url() {
        return this._url;
    }
    set url(path) {
        this._url = path;
    }
    get hideFlags() {
        return this._hideFlags;
    }
    set hideFlags(value) {
        this._hideFlags = value;
    }
    get is3D() {
        return this._nodeType === 1;
    }
    get destroyed() {
        return this._destroyed;
    }
    constructor() {
        super();
        this._bits = 0;
        this._reactiveBits = 0;
        this._hideFlags = 0;
        this._parent = null;
        this._destroyed = false;
        this._nodeType = 0;
        this.name = "";
        this._bits = initBits;
        this._reactiveBits = reactiveBits;
        this._children = [];
        this._$children = this._children;
        this._$container = this;
        this._initialize();
    }
    _initialize() {
        this._extra = {};
    }
    _setBit(bit, value) {
        if (((this._bits & bit) === 0) === !value)
            return false;
        if (value)
            this._bits |= bit;
        else
            this._bits &= ~bit;
        if ((bit & this._reactiveBits) != 0)
            this._onSetBit(bit, value);
        return true;
    }
    _getBit(bit) {
        return (this._bits & bit) !== 0;
    }
    _onSetBit(bit, value) {
        if ((bit & NodeFlags.DISPLAY) !== 0) {
            let ele = this._parent;
            let stage = ILaya.stage;
            let displayedInStage = this === stage;
            while (ele) {
                if ((ele._bits & NodeFlags.DISPLAY) !== 0) {
                    displayedInStage = (ele._bits & NodeFlags.DISPLAYED_INSTAGE) !== 0;
                    break;
                }
                if (ele === stage) {
                    displayedInStage = true;
                    break;
                }
                ele = ele._parent;
            }
            this._setBit(NodeFlags.DISPLAYED_INSTAGE, displayedInStage);
        }
    }
    _setBitUp(type) {
        let ele = this;
        ele._setBit(type, true);
        ele = ele._parent;
        while (ele) {
            if ((ele._bits & type) !== 0)
                return;
            ele._setBit(type, true);
            ele = ele._parent;
        }
    }
    onStartListeningToType(type) {
        if ((type === Event.DISPLAY || type === Event.UNDISPLAY) && (this._bits & NodeFlags.DISPLAY) === 0) {
            this._setBitUp(NodeFlags.DISPLAY);
        }
    }
    bubbleEvent(type, data) {
        let arr = [];
        arr.length = 0;
        let obj = this;
        while (obj) {
            if (obj.activeInHierarchy)
                arr.push(obj);
            obj = obj._parent;
        }
        let evt;
        if (data instanceof Event) {
            evt = data;
            evt._stopped = false;
        }
        for (let obj of arr) {
            if (evt) {
                evt.setTo(type, obj, this);
                obj.event(type, data);
                if (evt._stopped)
                    break;
            }
            else
                obj.event(type, data);
        }
    }
    hasHideFlag(flag) {
        return (this._hideFlags & flag) != 0;
    }
    destroy(destroyChild = true) {
        if (this._destroyed)
            return;
        this._destroyed = true;
        this.destroyAllComponent();
        this._parent && this._parent._removeChild(this);
        for (let i = 0, n = this._children.length; i < n; i++) {
            let node = this._children[0];
            this._children.shift();
            if (!node)
                continue;
            node._setParent(null);
            if (destroyChild)
                node.destroy();
        }
        this.onDestroy();
        this.offAll();
    }
    onDestroy() {
    }
    destroyChildren() {
        for (let i = 0, n = this._$children.length; i < n; i++) {
            this._$children[0].destroy(true);
        }
    }
    get children() {
        return this._$children;
    }
    addChild(node) {
        return this.addChildAt(node, this._$children.length);
    }
    addChildren(...args) {
        let i = 0, n = args.length;
        while (i < n) {
            this.addChildAt(args[i++], this._$children.length);
        }
    }
    addChildAt(node, index) {
        if (index >= 0 && index <= this._$children.length) {
            if (node._$parent === this) {
                this.setChildIndex(node, index);
            }
            else {
                node._parent && node._parent.removeChild(node);
                this._$children.splice(index, 0, node);
                node._$parent = this;
                node._setParent(this._$container, index);
            }
            return node;
        }
        else {
            throw new OutOfRangeError(index);
        }
    }
    getChildIndex(node) {
        return this._$children.indexOf(node);
    }
    getChild(name, classType) {
        for (let child of this._$children) {
            if (child.name === name)
                return child;
        }
        return null;
    }
    getChildByName(name, classType) {
        return this.getChild(name, classType);
    }
    getChildAt(index, classType) {
        if (index >= 0 && index < this.numChildren)
            return this._$children[index];
        else
            throw new OutOfRangeError(index);
    }
    getChildByPath(path, classType) {
        let arr = path.split(".");
        let cnt = arr.length;
        let p = this;
        let obj;
        for (let i = 0; i < cnt; ++i) {
            obj = p.getChild(arr[i], classType);
            if (!obj)
                break;
            p = obj;
        }
        return obj;
    }
    findChild(name, classType) {
        for (let c of this._$children) {
            if (c.name == name)
                return c;
            if (!c.url) {
                c = c.findChild(name, classType);
                if (c)
                    return c;
            }
        }
        return null;
    }
    setChildIndex(node, index) {
        let oldIndex = this._$children.indexOf(node);
        if (oldIndex < 0)
            throw new Error("not a child of this node");
        this._setChildIndex(node, oldIndex, index);
        return node;
    }
    setChildIndexBefore(node, index) {
        let oldIndex = this._$children.indexOf(node);
        if (oldIndex == -1)
            throw new Error("not a child of this node");
        if (oldIndex < index)
            return this._setChildIndex(node, oldIndex, index - 1);
        else
            return this._setChildIndex(node, oldIndex, index);
    }
    _setChildIndex(node, oldIndex, index) {
        let cnt = this._$children.length;
        if (index > cnt)
            index = cnt;
        if (oldIndex == index)
            return oldIndex;
        this._$children.splice(oldIndex, 1);
        if (index >= this._$children.length)
            this._$children.push(node);
        else
            this._$children.splice(index, 0, node);
        this._$container._childChanged();
        return index;
    }
    _childChanged(child) {
    }
    removeChild(node, destroy) {
        let index = this._$children.indexOf(node);
        if (index == -1)
            throw new Error("not a child of this node");
        this._$children.splice(index, 1);
        node._setParent(null);
        if (destroy)
            node.destroy();
        return node;
    }
    removeSelf() {
        this._parent && this._parent._removeChild(this);
        return this;
    }
    removeChildByName(name, destroy) {
        let node = this.getChild(name);
        node && this.removeChild(node, destroy);
        return node;
    }
    removeChildAt(index, destroy) {
        let node = this._$children[index];
        this._$children.splice(index, 1);
        node._setParent(null);
        if (destroy)
            node.destroy();
        return node;
    }
    removeChildren(beginIndex, endIndex, destroy) {
        beginIndex = beginIndex || 0;
        if (endIndex == null)
            endIndex = -1;
        if (endIndex < 0 || endIndex >= this._$children.length)
            endIndex = this._$children.length - 1;
        for (let i = beginIndex; i <= endIndex; ++i)
            this.removeChildAt(beginIndex, destroy);
    }
    replaceChild(newNode, oldNode) {
        let index = this._$children.indexOf(oldNode);
        if (index == -1)
            throw new Error("not a child of this node");
        this.removeChildAt(index);
        return this.addChildAt(newNode, index);
    }
    _setContainer(container) {
        this._$container = container;
        this._$children = container._children;
    }
    _addChild(node, index) {
        let children = this._children;
        if (index == null)
            index = children.length;
        if (index >= 0 && index <= children.length) {
            if (node._parent === this) {
                let oldIndex = children.indexOf(node);
                children.splice(oldIndex, 1);
                if (index >= children.length)
                    children.push(node);
                else
                    children.splice(index, 0, node);
                this._childChanged(node);
            }
            else {
                node._parent && node._parent.removeChild(node);
                children.splice(index, 0, node);
                node._$parent = this;
                node._setParent(this, index);
            }
            return node;
        }
        else {
            throw new OutOfRangeError(index);
        }
    }
    _removeChild(node) {
        let index = this._children.indexOf(node);
        if (index == -1)
            throw new Error("not a child of this node");
        this._children.splice(index, 1);
        node._setParent(null);
        return node;
    }
    get numChildren() {
        return this._$children.length;
    }
    get parent() {
        return this._$parent;
    }
    isAncestorOf(node) {
        if (!node)
            return false;
        let p = node._parent;
        while (p) {
            if (p == this)
                return true;
            p = p._parent;
        }
        return false;
    }
    _setParent(value, index = -1) {
        if (value) {
            this._parent = value;
            this._onAdded();
            this.event(Event.ADDED);
            if ((this._bits & NodeFlags.DISPLAY) !== 0) {
                this._setBitUp(NodeFlags.DISPLAY);
                if (value.displayedInStage)
                    this._displayChild(this, true);
            }
            value._childChanged(this);
        }
        else {
            this._onRemoved();
            this.event(Event.REMOVED);
            let p = this._parent;
            if ((this._bits & NodeFlags.DISPLAY) !== 0)
                this._displayChild(this, false);
            this._parent = null;
            this._$parent = null;
            if (!p._destroyed)
                p._childChanged(this);
        }
    }
    get displayedInStage() {
        if ((this._bits & NodeFlags.DISPLAY) === 0)
            this._setBitUp(NodeFlags.DISPLAY);
        return (this._bits & NodeFlags.DISPLAYED_INSTAGE) !== 0;
    }
    _setDisplay(value) {
        if (((this._bits & NodeFlags.DISPLAYED_INSTAGE) !== 0) !== value) {
            this._setBit(NodeFlags.DISPLAYED_INSTAGE, value);
            if (value)
                this.event(Event.DISPLAY);
            else
                this.event(Event.UNDISPLAY);
        }
    }
    _displayChild(node, display) {
        for (let child of node._children) {
            if ((child._bits & NodeFlags.DISPLAY) === 0)
                continue;
            if (child._children.length > 0) {
                this._displayChild(child, display);
            }
            else {
                child._setDisplay(display);
            }
        }
        node._setDisplay(display);
    }
    contains(node) {
        if (node === this)
            return true;
        while (node) {
            if (node._parent === this)
                return true;
            node = node._parent;
        }
        return false;
    }
    timerLoop(delay, caller, method, args = null, coverBefore = true, jumpFrame = false) {
        this.timer.loop(delay, caller, method, args, coverBefore, jumpFrame);
    }
    timerOnce(delay, caller, method, args = null, coverBefore = true) {
        this.timer._create(false, false, delay, caller, method, args, coverBefore);
    }
    frameLoop(delay, caller, method, args = null, coverBefore = true) {
        this.timer._create(true, true, delay, caller, method, args, coverBefore);
    }
    frameOnce(delay, caller, method, args = null, coverBefore = true) {
        this.timer._create(true, false, delay, caller, method, args, coverBefore);
    }
    clearTimer(caller, method) {
        this.timer.clear(caller, method);
    }
    callLater(method, args = null) {
        this.timer.callLater(this, method, args);
    }
    runCallLater(method) {
        this.timer.runCallLater(this, method);
    }
    get scene() {
        return this._scene;
    }
    get stage() {
        return ILaya.stage;
    }
    get active() {
        return (this._bits & NodeFlags.ACTIVE) !== 0;
    }
    set active(value) {
        var _a;
        value = !!value;
        if (((this._bits & NodeFlags.ACTIVE) !== 0) !== value) {
            if (this._activeChangeScripts && this._activeChangeScripts.length !== 0)
                throw new Error("recursive set active");
            this._setBit(NodeFlags.ACTIVE, value);
            if (((_a = this._parent) === null || _a === void 0 ? void 0 : _a.activeInHierarchy) && (this._bits & NodeFlags.NOT_IN_PAGE) == 0) {
                this._processActive(value, true);
            }
        }
    }
    get activeInHierarchy() {
        return (this._bits & NodeFlags.ACTIVE_INHIERARCHY) !== 0;
    }
    _onActive() {
    }
    _onInActive() {
    }
    _onActiveInScene() {
    }
    _onInActiveInScene() {
    }
    onAwake() {
    }
    onEnable() {
    }
    onDisable() {
    }
    _parse(data, spriteMap) {
    }
    _setBelongScene(scene) {
        if (!this._scene || this._scene != scene) {
            this._scene = scene;
            this._onActiveInScene();
            for (let child of this._children)
                child._setBelongScene(scene);
        }
    }
    _setUnBelongScene() {
        if (this._scene !== this) {
            this._onInActiveInScene();
            this._scene = null;
            for (let child of this._children)
                child._setUnBelongScene();
        }
    }
    _processActive(active, fromSetter) {
        (this._activeChangeScripts) || (this._activeChangeScripts = []);
        let arr = this._activeChangeScripts;
        if (active)
            this._activeHierarchy(arr, fromSetter);
        else
            this._inActiveHierarchy(arr, fromSetter);
        for (let i = 0, n = arr.length; i < n; i++) {
            let comp = arr[i];
            comp.owner && comp._setActive(active);
        }
        arr.length = 0;
    }
    _activeHierarchy(activeChangeScripts, fromSetter) {
        this._setBit(NodeFlags.ACTIVE_INHIERARCHY, true);
        if (this._components) {
            for (let i = 0, n = this._components.length; i < n; i++) {
                let comp = this._components[i];
                if (comp._isScript())
                    (comp._enabled) && (activeChangeScripts.push(comp));
                else
                    comp._setActive(true);
            }
        }
        this._onActive();
        for (let child of this._children) {
            if ((child._bits & NodeFlags.ACTIVE) !== 0 && (child._bits & NodeFlags.NOT_IN_PAGE) === 0)
                child._activeHierarchy(activeChangeScripts, fromSetter);
        }
        if ((this._bits & NodeFlags.AWAKED) === 0) {
            this._setBit(NodeFlags.AWAKED, true);
            this.onAwake();
        }
        this.onEnable();
    }
    _inActiveHierarchy(activeChangeScripts, fromSetter) {
        this._onInActive();
        if (this._components) {
            for (let i = 0, n = this._components.length; i < n; i++) {
                let comp = this._components[i];
                if (comp._isScript())
                    comp._enabled && (activeChangeScripts.push(comp));
                else
                    comp._setActive(false);
            }
        }
        this._setBit(NodeFlags.ACTIVE_INHIERARCHY, false);
        for (let child of this._children) {
            if ((child._bits & NodeFlags.ACTIVE_INHIERARCHY) !== 0)
                child._inActiveHierarchy(activeChangeScripts, fromSetter);
        }
        this.onDisable();
    }
    _onAdded() {
        if (this._activeChangeScripts && this._activeChangeScripts.length !== 0) {
            throw new Error("recursive set active");
        }
        else {
            let parentScene = this._parent.scene;
            if (parentScene)
                this._setBelongScene(parentScene);
            if (this._parent.activeInHierarchy
                && (this._bits & NodeFlags.ACTIVE) !== 0
                && (this._bits & NodeFlags.NOT_IN_PAGE) === 0)
                this._processActive(true);
        }
    }
    _onRemoved() {
        if (this._activeChangeScripts && this._activeChangeScripts.length !== 0) {
            throw new Error("recursive set active");
        }
        else {
            if (this._parent.activeInHierarchy
                && (this._bits & NodeFlags.ACTIVE) !== 0
                && (this._bits & NodeFlags.NOT_IN_PAGE) === 0)
                this._processActive(false);
            if (this._parent.scene)
                this._setUnBelongScene();
        }
    }
    _addComponentInstance(comp) {
        var _a;
        if (comp._singleton && this.getComponent(comp.constructor)) {
            console.warn("the component is singleton, can't add the second one.", comp);
            return;
        }
        if (!this._components)
            this._components = [];
        this._components.push(comp);
        comp._setOwner(this);
        if (this.activeInHierarchy)
            comp._setActive(true);
        (_a = this._componentsChanged) === null || _a === void 0 ? void 0 : _a.call(this, comp, 0);
    }
    _destroyComponent(comp) {
        var _a;
        if (!this._components)
            return;
        let i = this._components.indexOf(comp);
        if (i != -1) {
            this._components.splice(i, 1);
            comp._destroy();
            (_a = this._componentsChanged) === null || _a === void 0 ? void 0 : _a.call(this, comp, 1);
        }
    }
    destroyAllComponent() {
        var _a;
        if (!this._components)
            return;
        for (let i = 0, n = this._components.length; i < n; i++) {
            let item = this._components[i];
            item && !item.destroyed && item._destroy();
        }
        this._components.length = 0;
        (_a = this._componentsChanged) === null || _a === void 0 ? void 0 : _a.call(this, null, 2);
    }
    _cloneTo(destObject, srcRoot, dstRoot) {
        if (this._components) {
            for (let i = 0, n = this._components.length; i < n; i++) {
                let destComponent = destObject.addComponent(this._components[i].constructor);
                this._components[i]._cloneTo(destComponent);
            }
        }
    }
    addComponentInstance(component) {
        if (component.owner)
            throw new Error("the component is belong to other node.");
        this._addComponentInstance(component);
        return component;
    }
    addComponent(componentType) {
        let comp = Pool.createByClass(componentType);
        if (!comp)
            throw new Error("missing " + componentType.toString());
        this._addComponentInstance(comp);
        return comp;
    }
    getComponent(componentType) {
        if (this._components) {
            for (let i = 0, n = this._components.length; i < n; i++) {
                let comp = this._components[i];
                if (comp instanceof componentType)
                    return comp;
            }
        }
        return null;
    }
    get components() {
        return this._components || ARRAY_EMPTY;
    }
    getComponents(componentType) {
        let arr = [];
        if (this._components) {
            for (let i = 0, n = this._components.length; i < n; i++) {
                let comp = this._components[i];
                if (comp instanceof componentType) {
                    arr = arr || [];
                    arr.push(comp);
                }
            }
        }
        return arr;
    }
    get timer() {
        return this._scene ? this._scene.timer : ILaya.timer;
    }
    onAfterDeserialize() { }
}
